var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"base-button",class:{'base-button--full': _vm.full, 'base-button--danger': _vm.danger, 'base-button--success': _vm.success}},_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.label)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }